import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
export const FontWeightsOptionsArray = ['400', '600', '700'] as const;
export type FontWeightOptions = (typeof FontWeightsOptionsArray)[number];

export const fontWeight = system({
    fontWeight: true,
});
export interface FontWeightProps<ThemeType extends Theme = RequiredTheme> {
    fontWeight?: ResponsiveValue<FontWeightOptions, ThemeType> | undefined;
}
